export enum MenuBarName {
  Dashboard = "Dashboard",
  CustomerAdmin = "Customer admin",
}
